$(document).ready(function(){
  // set recharge app option on swatch click
  $(".product-swatch-wrap ul li").click(function(){
  	$(this).addClass("active");
    $(this).siblings().removeClass("active");
    
    setRechargeOption($(this).attr("data-value"));
  });
  
  // init recharge app load
  var rechargeTimer = setInterval(function(){
    if($("#rc_container").is(":visible")){
      $(".product-swatch-wrap ul li:eq(0)").trigger("click");
      
      setRechargeOption($(".product-swatch-wrap ul li:eq(0)").attr("data-value"));
      clearInterval(rechargeTimer);
    }
  }, 500);
});

function setRechargeOption(rValue){
  switch(rValue) {
    case "1-time":
    	$(".rc_block__type__onetime input[type='radio']").prop("checked", true).trigger("click").trigger("change"); 
      	break;
    case "3-mnths":
        $(".rc_block__type__autodeliver input[type='radio']").prop("checked", true).trigger("click").trigger("change");
      	$(".rc_block__type__autodeliver select[name='properties[shipping_interval_frequency]']").val("3").trigger("change");
        break;
    case "6-mnths":
        $(".rc_block__type__autodeliver input[type='radio']").prop("checked", true).trigger("click").trigger("change");
      	$(".rc_block__type__autodeliver select[name='properties[shipping_interval_frequency]']").val("6").trigger("change");
        break;
    default:
      // code block
  }
}